import { useEffect, useState } from 'react';
import { apiFetch } from '../../utils/apiClient';

/**
 * Актуальная версия приложения со стороны сервера.
 *
 * Ручка публичная и намеренно без авторизации — поэтому обычный fetch.
 * Проверка версии должна работать и на экране входа, где сессии ещё нет.
 */
export function useAppVersion() {
    const [data, setData] = useState(null);

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        let isMounted = true;
        const fetchVersion = async () => {
            try {
                setLoading(true);
                setError(null);

                const response = await apiFetch(
                    `/api/versions`,
                    {
                        method: 'GET',
                    }
                );

                if (!response.ok) {
                    throw new Error('Не удалось получить версию');
                }

                const json = await response.json();
                console.log(json);

                if (isMounted) {
                    setData(json);
                }
            } catch (err) {
                if (isMounted) {
                    setError(
                        err
                            ? err.message
                            : 'Не удалось получить версию'
                    );
                }
            } finally {
                if (isMounted) {
                    setLoading(false);
                }
            }
        };

        fetchVersion();

        return () => {
            isMounted = false;
        };

    }, []);

    return {
        data: data,
        loading,
        error,
    };

}
